import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const AdContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 160px;
  min-height: 600px;
  position: sticky;
  top: 120px;
  
  @media (max-width: 1200px) {
    display: none;
  }
`;

const PlaceholderAd = styled.div`
  width: 160px;
  height: 600px;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  border: 2px dashed #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: Arial, sans-serif;
`;

const PlaceholderText = styled.div`
  color: #666;
  font-size: 12px;
  margin-bottom: 10px;
  font-weight: bold;
`;

const PlaceholderSubtext = styled.div`
  color: #999;
  font-size: 10px;
  line-height: 1.4;
`;

const AdDimensions = styled.div`
  color: #888;
  font-size: 11px;
  margin-top: 10px;
  font-weight: bold;
`;

const VerticalAdBanner = () => {
  const adRef = useRef(null);
  const isInitialized = useRef(false);
  const isDevelopment = process.env.NODE_ENV === 'development';

  useEffect(() => {
    // In production, initialize real AdSense
    if (!isDevelopment) {
      // Prevent multiple initializations
      if (isInitialized.current) {
        return;
      }

      // Ensure AdSense script is loaded
      if (window.adsbygoogle) {
        try {
          window.adsbygoogle.push({});
          isInitialized.current = true;
        } catch (error) {
          console.error('AdSense error:', error);
        }
      }
    }
  }, [isDevelopment]);

  // Show placeholder in development
  if (isDevelopment) {
    return (
      <AdContainer>
        <PlaceholderAd>
          <PlaceholderText>📱 AdSense Preview</PlaceholderText>
          <PlaceholderSubtext>
            This is where your vertical banner ad will appear in production.
            <br/><br/>
            Publisher ID:<br/>
            ca-pub-1679101309275457
            <br/><br/>
            Ad Slot:<br/>
            5538371288
          </PlaceholderSubtext>
          <AdDimensions>160 × 600px</AdDimensions>
        </PlaceholderAd>
      </AdContainer>
    );
  }

  // Show real AdSense in production
  return (
    <AdContainer>
      <ins 
        ref={adRef}
        className="adsbygoogle"
        style={{
          display: 'block',
          width: '160px',
          height: '600px',
        }}
        data-ad-client="ca-pub-1679101309275457"
        data-ad-slot="5538371288"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </AdContainer>
  );
};

export default VerticalAdBanner; 